import { render, staticRenderFns } from "./materialExportPage.vue?vue&type=template&id=6a74d72e&scoped=true"
import script from "./materialExportPage.vue?vue&type=script&lang=js"
export * from "./materialExportPage.vue?vue&type=script&lang=js"
import style0 from "./materialExportPage.vue?vue&type=style&index=0&id=6a74d72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74d72e",
  null
  
)

export default component.exports